import React from "react";
import { renderSurveyFormattedTextToHtml } from "view/pages/Forms/EditFormDetails/Components/SurveyJs/utils/renderSurveyFormattedTextToHtml";

interface QuestionPromptProps {
  label?: string;
  description?: string;
  name?: string;
  required?: boolean;
  editMode?: boolean;
  labelSize?: string;
  className?: string;
  hideLabel?: boolean;
}

const labelSizeClassMap: Record<string, string> = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-md",
  lg: "text-lg",
  xl: "text-xl",
};

const QuestionPrompt: React.FC<QuestionPromptProps> = ({
  label,
  description,
  name,
  required = false,
  editMode = true,
  labelSize,
  className = "",
  hideLabel = false,
}) => {
  const resolvedLabel = label || name;
  const labelSizeClass = labelSizeClassMap[labelSize || ""] || "text-md";

  return (
    <>
      {!hideLabel && !!resolvedLabel && (
        <div className={`w-full pb-1 ${className}`}>
          <div className="flex items-start gap-1">
            <div
              className={`survey-formatted-html survey-formatted-html--title ${labelSizeClass} text-left font-Overpass text-primary dark:text-caption ${editMode ? "font-medium" : "font-regular"}`}
              dangerouslySetInnerHTML={{
                __html: renderSurveyFormattedTextToHtml(resolvedLabel, "block"),
              }}
            />
            {required && <span className="text-accent_1Dark">*</span>}
          </div>
        </div>
      )}
      {/* {!!description && (
        <div
          className="survey-formatted-html survey-formatted-html--description w-full pb-2 text-left text-sm font-Overpass text-textLightExtra"
          dangerouslySetInnerHTML={{
            __html: renderSurveyFormattedTextToHtml(description, "block"),
          }}
        />
      )} */}
    </>
  );
};

export default QuestionPrompt;
